<template>
  <div class="container">
    <b-row>
      <b-container>
        <h1 class="text-center py-2">
          {{labels.title}}
        </h1>
      </b-container>
    </b-row>
    <b-row>
      <b-container>
        <h4 class="text-center border-bottom">
          {{labels.subtitle}}
        </h4>
        <b-col md="8" class="mx-auto">
          <ul>
            <li v-for="(item, idx) in labels.instructive" :key="idx">{{ item }}</li>
          </ul>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-if="!isLoading">
      <b-container>
        <b-col md="10" class="mx-auto"> 
          <b-button @click="goToCreateUser()" id="create-btn">{{
              labels.create
            }}</b-button>
        </b-col>
      </b-container>
      <!-- <div class="row p-1 justify-content-center"> -->
          <div class="col-md-4">
            <md-field md-inline>
              <label>{{labels.name}}</label>
              <md-input v-model="searchUser" @input="searchOnTableUser"></md-input>
            </md-field>
          </div>
          <div class="col-md-4">
            <md-field md-inline>
              <label>{{labels.email}}</label>
              <md-input v-model="searchEmail" @input="searchOnTableEmail"></md-input>
            </md-field>
          </div>
      <!-- </div> -->
      <b-container v-if="!isEmpty" class="pb-5">
        <!-- <h4 class="text-center">
          {{labels.info}}
        </h4> -->
        <!-- <b-col md="12" class="mx-auto">
          <md-table
            v-model="searched"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card
          >
            <md-table-toolbar>
              <md-field md-clearable class="md-toolbar-section-start">
                <md-input
                  :placeholder="labels.search"
                  v-model="search"
                  @input="searchOnTable"
                />
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }" @click="showInfo(item.id)">
              <md-table-cell :md-label="labels.createdAt" md-sort-by="createdAt">{{
                item.createdAt
              }}</md-table-cell>
              <md-table-cell :md-label="labels.name" md-sort-by="name">{{
                item.username
              }}</md-table-cell>
              <md-table-cell :md-label="labels.email" md-sort-by="email">{{
                item.email
              }}</md-table-cell>
              <md-table-cell
                  :md-label="labels.status"
                  md-sort-by="enabled"
                  >
                  <span v-if="item.enabled > 0" class="policy-active">{{labels.active}}</span>
                  <span v-else class="policy-pending">{{labels.inactive}}</span>
                  </md-table-cell>
            </md-table-row>
          </md-table>
        </b-col> -->
        <table class="table table-hover table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col">{{labels.createdAt}}</th>
              <th scope="col">{{labels.name}}</th>
              <th scope="col">{{labels.email}}</th>
              <th scope="col">{{labels.informationUser}}</th>
              <th scope="col">{{labels.edit}}</th>
              <th scope="col">{{labels.inactivate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pro in datosPaginados" :key="pro.id">
              <td>{{ pro.createdAt }}</td>
              <td>{{ pro.username }}</td>
              <td>{{ pro.email }}</td>
              <td>
                <md-button @click="showInfo(pro.id)" class = "md-raised md-primary btn-info"><md-icon>menu</md-icon></md-button>
              </td>
              <td>
                <md-button @click="editUser(pro.id)" class = "md-raised md-primary btn-edit"><md-icon>edit</md-icon></md-button>
              </td>
              <td>
                <md-button @click="inactivaUser(pro.id)" class = "md-raised md-accent"><md-icon>delete</md-icon></md-button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-center">
            <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Previous</a></li>
            <li v-for="pagina in totalPaginas()" :key="pagina" v-on:click="getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
            <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Next</a></li>
          </ul>
        </nav>
        <b-col
          md="6"
          class="mx-auto empty-table pt-4"
          v-if="searched.length == 0 && users.length > 0 && !isLoading"
        >
          <h3>{{labels.notFound}}</h3>
          <p>{{labels.notFoundMessage}}: <span>{{ search }}</span></p>
        </b-col>
      </b-container>
      <b-container v-else>
        <b-col md="2" class="mx-auto">
          <div class="success-svg mb-4" :class="{ active: isEmpty }">
            <img src="../../assets/imgs/file-2.svg" alt="warning" />
          </div>
        </b-col>
        <b-col md="12" class="justify-content-around">
          <span id="message" v-if="isEmpty">{{labels.empty}}</span>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{labels.information}}</md-dialog-title>
      <md-dialog-content>
          <!-- <b-row>
            <b-col>
              <h5>{{labels.companyId}}:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.companyId}}</h5>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col>
              <h5>{{labels.name}}:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.username}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>{{labels.email}}:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.email}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>{{labels.idNumber}}:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.idNumber}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>{{labels.phonenumber}}</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.phone}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>{{labels.role}}</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.role}}</h5>
            </b-col>
          </b-row>
         
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-accent" @click="showDialog = false">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDialogEdit">
      <md-dialog-title>{{labels.information}}</md-dialog-title>
      <md-dialog-content>
        <b-col md="8" lg="12" class="p-4 mx-auto">
          <b-form-group @submit.prevent="editaInfoUser">
            <label>{{labels.name}} </label>
            <md-field>
              <!-- <label>{{labels.name}} </label> -->
              <md-input v-model="formEdit.nameUser" type="text"></md-input>
            </md-field><br>
            <label>{{labels.idNumber}} </label>
            <md-field>
              <!-- <label>{{labels.name}} </label> -->
              <md-input v-model="formEdit.identificacionUser" type="number"></md-input>
            </md-field><br>
            <label>{{labels.phonenumber}} </label>
            <md-field>
              <!-- <label>{{labels.name}} </label> -->
              <md-input v-model="formEdit.telefonoUser" type="number"></md-input>
            </md-field><br>
            <label>{{labels.email}} </label>
            <md-field>
              <!-- <label>{{labels.name}} </label> -->
              <md-input v-model="formEdit.correo" type="text"></md-input>
            </md-field><br>
            <label>{{labels.role}} </label>
            <md-field>
              <md-select v-model="formEdit.role" :placeholder="labels.role">
                <md-option value="COM" v-if="$store.state.userRole == 'COM'">Complement</md-option>
                <md-option value="ADM">Administrar</md-option>
                <md-option value="APP">Aprobar</md-option>
                <md-option value="CHK">Revisar</md-option>
                <md-option value="AGN">Asignar</md-option>
              </md-select>
            </md-field>
            <!-- <md-field>
              <md-select v-model="rolSeleccionado" >
                  <md-option v-for="rol in roles" :value="rol.id" :key="rol.id">{{rol.nombre}}</md-option>
              </md-select>
            </md-field><br> -->
            <!-- <label>{{labels.role}} </label> -->
            <!-- <md-field> -->
              <!-- <Select2 v-model="rolSelected" :options="myOptions" placeholder="Seleccione..." class="optionSeleted"></Select2> -->
            <!-- </md-field><br> -->
          </b-form-group>
          <md-dialog-actions>
            <md-button class="md-primary" @click="editaInfoUser()">Guardar</md-button>
            <md-button class="md-accent" @click="showDialog = false">Cerrar</md-button>
          </md-dialog-actions>
        </b-col>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import User from "@/services/User";
import Rol from "@/services/Roles";
// import Select2 from 'v-select2-component';
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.username).includes(toLower(term))
    );
  }
  return items;
};

const searchByEmail = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.email).includes(toLower(term))
    );
  }
  return items;
};

export default {
  name: "List",
  // components: {Select2},

  data: () => ({
    rolSeleccionado: {},//<-- el seleccionado estará aquí
    myOptions: [],
    nameUser: '',
    identificacionUser: '',
    telefonoUser: '',
    correo: '',
    rolSelected: '',
    currentSort: "createdAt",
    currentSortOrder: "asc",
    showDialog: false,
    showDialogEdit: false,
    dialogItem: {},
    users: [],
    roles: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    filename: "List.xls",
    elementosPorPagina:10,
    datosPaginados: [],
    paginaActual: 1,
    searchUser: null,
    searchEmail: null,
    formEdit: {
      nameUser: '',
      identificacionUser: '',
      telefonoUser: '',
      correo: '',
      idUser: '',
      role: '',
    },
  }),
  computed:{
    labels(){
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Administra los usuarios que utilizan la APP",
          subtitle: "Instrucciones",
          instructive: ["Bienvenid@ a la plataforma para la visualización y creación de usuarios"],
          info: "Información General",
          search: "Buscar por Nombre de Usuario",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Fecha Creación",
          name: "Nombre del usuario",
          email: "Correo Electrónico",
          informationUser: "Información",
          edit: "Editar",
          inactivate: "Inactivar",
          companyId: "Id de la Compañia",
          phonenumber: "Teléfono de contacto",
          idNumber: "Número de identificación",
          role: "Rol del Usuario",
          empty: "Aún no cuentas con usuarios",
          create: "Crear",
          active: "Activo",
          inactive: "Inactivo",
          status: "Estado"
        }
      }else {
        return {
          title: "Invoice Visualization Platform",
          subtitle: "Instructions",
          instructive: ["Welcome to the platform for the visualization and creation of users."],
          info: "General Information",
          search: "Search by User Name",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Created Date",
          name: "User Name",
          email: "Email",
          informationUser: "Information",
          edit: "Edit",
          inactivate: "Inactivate",
          companyId: "Company Id",
          phonenumber: "Contact Number",
          idNumber: "Identification Id",
          role: "Role",
          empty: "You don't have users yet",
          create: "Create",
          active: "Activo",
          inactive: "Inactive",
          status: "Status"
        }
      }
    }
  },
  methods: {
    goToCreateUser(){
      this.$router.push({path: '/users/create'})
    },
    showInfo(id) {
      const currentIdx = this.users.findIndex((obj) => obj.id == id);
      this.dialogItem = this.users[currentIdx];
      // console.log(this.dialogItem)
      this.showDialog = true
    },
    editUser(id){
      // console.log(id)
      this.showDialogEdit = true
      const currentIdx = this.users.findIndex((obj) => obj.id == id);
      this.dialogItem = this.users[currentIdx];
      this.formEdit.nameUser = this.dialogItem.username;
      this.formEdit.identificacionUser = this.dialogItem.idNumber;
      this.formEdit.telefonoUser = this.dialogItem.phone;
      this.formEdit.correo = this.dialogItem.email;
      this.formEdit.idUser = id;
    },
    editaInfoUser(){
      // console.log(this.formEdit)
      this.isLoading = true;
      User.updateUser(this.formEdit)
      .then(() => {
        // console.log(res)
        this.$toast.success("Usuario editado correctamente")
        location. reload()
        this.isLoading = false;
        this.showDialogEdit = false;
      })
      .catch(() =>{
        this.error = true;
      })

    },
    inactivaUser(id){
      // console.log(id)
      this.isLoading = true;
      User.inactivaUser(id).then(() => {
        this.$toast.success("Usuario inactivado correctamente")
        location. reload()
        this.isLoading = false;
      });
    },
    deleteUser(id) {
      this.isLoading = true;
      User.deleteUser(id).then(() => {
        this.isLoading = false;
      });
      this.users = this.users.filter( user => user.id != id );
      this.searched = this.users
    },
    customSort(value) {
      // console.log(value);
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === "desc") {
          return a[sortBy].toString().localeCompare(b[sortBy].toString());
        }

        return b[sortBy].toString().localeCompare(a[sortBy].toString());
      });
    },
    searchOnTableUser() {
      this.searchEmail = '';
      this.datosPaginados = searchByName(this.users, this.searchUser);
      if(this.searchUser == ''){
        this.getDataPagina(1)
      }
    },
    searchOnTableEmail() {
      this.searchUser = '';
      this.datosPaginados = searchByEmail(this.users, this.searchEmail);
      if(this.searchEmail == ''){
        this.getDataPagina(1)
      }
    },
    totalPaginas(){
      return Math.ceil(this.searched.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      this.datosPaginados = [];
      this.paginaActual = noPagina;
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);

      this.datosPaginados = this.searched.slice(ini,fin);
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active':'';
    },
    getOptions(data){
      let optRol = {};
      for(let ind=0; ind < data.length; ind++){
        optRol = { id: data[ind].id, text: data[ind].nombre }
        this.myOptions.push(optRol)
      }
      // console.log(this.myOptions)
    }
  },
  mounted() {
    this.isLoading = true;
    User.getAllUsers(this.$store.state.userName)
      .then((result) => {
        // console.log(result.data)
        this.users = result.data.users;
        this.searched = this.users;
        this.getDataPagina(1);
        if (this.users.length == 0) {
          this.isEmpty = true;
        }
      })
      .catch(() => {
        // console.log(error);
        this.error = true;
      })
      .finally(() => {
        this.isLoading = false;
      });

    Rol.getAllRoles()
    .then((rta) => {
      // console.log(rta.data.roles)
      this.roles = rta.data.roles;
      this.getOptions(rta.data.roles);
    })
    .catch(() => {
      // console.log(error);
      this.error = true;
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style src="../main.css">
</style>
